export const FLAG_GETTING_BUS_ACTIVITY_ASSIGNMENTS =
  'FLAG_GETTING_BUS_ACTIVITY_ASSIGNMENTS';
export const GET_BUS_ACTIVITY_ASSIGNMENTS = 'GET_BUS_ACTIVITY_ASSIGNMENTS';
export const CLEAR_BUS_ACTIVITY_ASSIGNMENTS = 'CLEAR_BUS_ACTIVITY_ASSIGNMENTS';
export const FLAG_BUS_ACTIVITY_ASSIGNMENT_ACTIVITY =
  'FLAG_BUS_ACTIVITY_ASSIGNMENT_ACTIVITY';
export const GET_BUS_ACTIVITY_ASSIGNMENT = 'GET_BUS_ACTIVITY_ASSIGNMENT';
export const CLEAR_BUS_ACTIVITY_ASSIGNMENT = 'CLEAR_BUS_ACTIVITY_ASSIGNMENT';
